import * as yup from 'yup';
import { CurrencyCode } from '../../types';
export const debitAccountHolderSchema = yup.object({
    accountHolderCode: yup.string().required(),
    description: yup.string().required(),
    paymentType: yup.string().oneOf(['PaymentFee', 'BalanceAccount']).required(),
    amount: yup.object({
        value: yup.number().required(),
        currency: yup.string().oneOf(Object.values(CurrencyCode)).required(),
    }),
});
export const getMerchantCheckingAccountSchema = yup.object({
    accountHolderCode: yup.string().required(),
});
//# sourceMappingURL=debitMerchant.js.map